import React, { useState } from 'react';
import SearchBar from '../common/Searchbar';
import WidgetList from './WidgetList';
import closeIcon from '../../assets/images/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { WidgetElement } from '../../types/WidgetElement';
import { setWidgetOpen } from '../../features/Widget/WidgetOpenSlice';

interface WidgetModalProps {
    items: WidgetElement[];
}

const WidgetModal: React.FC<WidgetModalProps> = ({ items }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');

    const dispatch = useDispatch();
    const isopenWidget = useSelector(
        (state: { WidgetOpen: { isOpen: boolean } }) => state.WidgetOpen.isOpen
    );

    const WidgetclickHandler = () => {
        dispatch(setWidgetOpen(!isopenWidget));
    };

    // Filter items based on the search term
    const filteredItems = items.filter((chapter) =>
        chapter?.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center w-full h-full z-50 ">
            <div className="modal bg-white pb-6 pt-4 px-12 rounded-xl shadow-lg flex flex-col font-sans lg:w-[60rem] h-[40rem] ">
                <div className="flex justify-between ">
                    <div className="flex items-center ">
                        <h1 className="text-2xl text-black text-nowrap ">
                            Widgets
                        </h1>
                        <SearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            placeHolder="Search Widget"
                        />
                    </div>
                    <div>
                        <button
                            className="mt-2"
                            onClick={WidgetclickHandler}
                            data-testid="lp-modal-close-button"
                        >
                            <img src={closeIcon} alt="close icon" />
                        </button>
                    </div>
                </div>
                <hr className="border-solid border-gray-300 mt-4 -mx-12" />
                <div className="overflow-y-scroll custom-scrollbar">
                    <WidgetList items={filteredItems} />
                </div>
            </div>
        </div>
    );
};

export default WidgetModal;
